import React from 'react';
import mainLogo from '../../assets/icons/Logo.svg';
import { Link } from 'react-router-dom';

interface ActivationHeaderProps {
  resellerLogoUrl?: string;
  resellerName?: string;
  resellerCode?: string;
}

const ActivationHeader: React.FC<ActivationHeaderProps> = ({
  resellerLogoUrl,
  resellerName,
  resellerCode
}) => {
  return (
    <div className="activation-header">
      <div className="activation-header__main-logo">
        <Link to="/">
          <img src={mainLogo} alt="TruHu" />
        </Link>
      </div>

      {(resellerLogoUrl || resellerName || resellerCode) && (
        <h2 className="activation-header__title">
          <div className="activation-header__reseller">
            {resellerLogoUrl && (
              <img
                src={resellerLogoUrl}
                alt={resellerName || 'Partner'}
                className="activation-header__reseller-logo"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            )}
            {resellerName && (
              <span className="activation-header__reseller-name">{resellerName}</span>
            )}
            <span className="activation-header__activate-text">Activation</span>
          </div>
        </h2>
      )}
    </div>
  );
};

export default ActivationHeader;
